import { SiteHelper } from '../../common/utils/SiteHelper';
import { NavInit } from './NavInit';

const HeaderInit = (element) => {
    const header = document.querySelector('.ada-header');
    const headerWrapper = document.querySelector('.header');
    const maintHeader = document.querySelector('.ada-header--transparent');
    const homePageHeader = document.querySelector('.ada-header-home');
    //TODO: Need to update position of header on NA site. Adding this temporary workaround
    if (SiteHelper.isIntranetSite()) {
        if (header) {
            header.classList.add('ada-header--na');
        }
    }
    if (header) {
        //replace sharepoint white spaces before doing any processing
        const headerText = header.innerHTML;
        const replacedText = String(headerText).replace(/\u200B/g,'');
        header.innerHTML = replacedText;

        //initialize the Nav with the configured/required links
        NavInit(header);

        // const navLinks = header.getElementsByTagName('li');
        // const listItems = Array.prototype.slice.call(navLinks);
        // const navToggle = document.querySelector('.ada-nav-toggle');

        // const hideNavDropdowns = (e) => {
        //     dropdownLinks.map((item) => {
        //         if (!item.contains(e.target)) {
        //             item.classList.remove('active');
        //         }
        //     });
        // };

        // listItems.map((el) => {
        //     if (el.getElementsByTagName('ul').length > 0) {
        //         el.classList.add('js-ada-has-dropdown');
        //     }
        // });

        // const dropdownLinks = Array.prototype.slice.call(document.querySelectorAll('.js-ada-has-dropdown'));
        // dropdownLinks.map((link) => {
        //     link.addEventListener('click', (e) => {
        //         e.stopImmediatePropagation();
        //         hideNavDropdowns(e);
        //         e.currentTarget.classList.toggle('active');
        //     })
        // });
        
        // window.addEventListener('scroll', (e) => {
        //     if (document.documentElement.scrollTop || document.body.scrollTop > 0) {
        //         headerWrapper.style.height = header.clientHeight + 'px';
        //         maintHeader ? maintHeader.classList.add('sticky') : '';
        //         homePageHeader ? header.classList.add('sticky') : '';
        //     } else {
        //         maintHeader ? maintHeader.classList.remove('sticky') : '';
        //         homePageHeader ? header.classList.remove('sticky') : '';
        //     }
        // });

        // window.addEventListener('click', (e) => {
        //     hideNavDropdowns(e);
        // });

        // window.addEventListener('resize', (e) => {
        //     if (!header.classList.contains('ada-header--transparent')){
        //         headerWrapper.style.height = header.clientHeight + 'px'; 
        //     }
        // });

        // if (navToggle) {
        //     navToggle.addEventListener('click', (e) => {
        //         e.stopImmediatePropagation();
        //         document.body.classList.toggle('js-nav-expanded');
        //         document.getElementsByTagName('html')[0].classList.toggle('ada-noScroll');
        //     });
        // }

        // document.addEventListener('DOMContentLoaded', () => {
        //     headerWrapper.style.height = header.clientHeight + 'px';
        // });
    }
};

export default HeaderInit;


// WEBPACK FOOTER //
// ./src/nams2020/webparts/Header/index.js